var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClarityListLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 465 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.75 103.333H310V129.166H193.75V103.333Z",
    className: "svgFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.75 155H310V180.834H193.75V155Z",
    className: "svgFill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.75 206.666H310V232.499H193.75V206.666Z",
    className: "svgFill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.75 258.333H310V284.167H193.75V258.333Z",
    className: "svgFill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.75 309.999H310V335.832H193.75V309.999Z",
    className: "svgFill"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.083 103.333H167.917V129.166H142.083V103.333Z",
    className: "svgFill"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.083 155H167.917V180.834H142.083V155Z",
    className: "svgFill"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.083 206.666H167.917V232.499H142.083V206.666Z",
    className: "svgFill"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.083 258.333H167.917V284.167H142.083V258.333Z",
    className: "svgFill"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.083 309.999H167.917V335.832H142.083V309.999Z",
    className: "svgFill"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M361.666 25.8334H103.333C96.4817 25.8334 89.9109 28.5552 85.0662 33.3998C80.2215 38.2445 77.4998 44.8153 77.4998 51.6668V413.333C77.4998 420.185 80.2215 426.756 85.0662 431.6C89.9109 436.445 96.4817 439.167 103.333 439.167H361.666C368.518 439.167 375.089 436.445 379.933 431.6C384.778 426.756 387.5 420.185 387.5 413.333V51.6668C387.5 44.8153 384.778 38.2445 379.933 33.3998C375.089 28.5552 368.518 25.8334 361.666 25.8334ZM361.666 413.333H103.333V51.6668H361.666V413.333Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityListLine2);
export default __webpack_public_path__ + "static/media/clarity_list-line2.37f1b33b.svg";
export { ForwardRef as ReactComponent };